
const getters = {

 windowBreakPoint: state => {

    if (state.windowWidth >= 1200) return "xl"
    else if (state.windowWidth >= 992) return "lg"
    else if (state.windowWidth >= 768) return "md"
    else if (state.windowWidth >= 576) return "sm"
    else return "xs"
  },
  isInCart: state => itemId => {
      return state.cartItems.some((item) => item.objectID == itemId )
  },
  isInWishRestaurantList: state => itemId => {
      return state.wishRestaurant.some((item) => item.objectID == itemId )
  },
  isInSelectedRestaurant: state => itemId => {
      return state.selectedRestaurant.some((item) => item.objectID == itemId )
  },
  getCartItem: state => itemId => {
    const result = state.cartItems.filter((item) => item.objectID == itemId)
    return result.length ? result.pop() : []
  },
}

export default getters
